import { Component } from '@angular/core';
import { ClaimsService } from '@core/authentication/claims.service';
import { AggregatorFeatureFlagService } from '@core/services/aggregator-feature-flag.service';
import { AggregatorFeatureFlag } from '@env/aggregator/aggregator.interface';

import { SidebarSubMenuItem } from '@shared/components/menu/sidebar-sub-menu/sub-menu.model';

@Component({
  selector: 'spark-reports-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class ReportsLayoutComponent {
  constructor(
    private readonly featureFlagService: AggregatorFeatureFlagService,
    private readonly claimsService: ClaimsService
  ) {}

  items: SidebarSubMenuItem[][] = [this.getMenuItems()];

  private getMenuItems(): SidebarSubMenuItem[] {

    const contactsReport: SidebarSubMenuItem[] =
      this.featureFlagService.isEnabled(AggregatorFeatureFlag.ContactsReport) ? 
      [
        {
          label: 'Contacts',
          link: ['contacts']
        }
      ]
      : [];

    const opportunitiesReport: SidebarSubMenuItem[] =
      this.featureFlagService.isEnabled(AggregatorFeatureFlag.OpportunitiesReport) ? 
      [
        {
          label: 'Opportunities',
          link: ['opportunities']
        }
      ]
      : [];

    const refixReport: SidebarSubMenuItem[] =
      this.featureFlagService.isEnabled(AggregatorFeatureFlag.RefixReport) ? 
      [
        {
          label: 'Refixes',
          link: ['refixes']
        }
      ]
      : [];

    const canvasMetricsReport: SidebarSubMenuItem[] =
      this.featureFlagService.isEnabled(AggregatorFeatureFlag.CanvasMetricsReport) ? 
      [
        {
          label: 'Email Campaign Metrics',
          link: ['email-campaign-metrics']
        }
      ]
      : [];

    return [
      ...contactsReport, 
      ...opportunitiesReport, 
      ...refixReport,
      ...canvasMetricsReport
    ]
  }
}
